"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = Radio;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _FieldSet = _interopRequireDefault(require("../FieldSet"));
var _Box = _interopRequireDefault(require("../Box"));
var _VisuallyHidden = _interopRequireDefault(require("../VisuallyHidden"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _styledComponents = require("./styled-components");
var _Radio = _interopRequireDefault(require("../Radio"));
var _focus = require("@react-aria/focus");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function Radio(_ref) {
  var checked = _ref.checked,
    name = _ref.name,
    id = _ref.id,
    index = _ref.index,
    checkedIndex = _ref.checkedIndex,
    onChange = _ref.onChange,
    optionCount = _ref.optionCount,
    label = _ref.label,
    value = _ref.value,
    variant = _ref.variant,
    error = _ref.error,
    warning = _ref.warning,
    isDisabled = _ref.isDisabled,
    required = _ref.required;
  var _useFocusRing = (0, _focus.useFocusRing)(),
    isFocusVisible = _useFocusRing.isFocusVisible,
    focusProps = _useFocusRing.focusProps;
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.Option, {
    checked: checked,
    checkedIndex: checkedIndex,
    index: index,
    variant: variant,
    optionCount: optionCount,
    warning: warning,
    error: error,
    isDisabled: isDisabled,
    htmlFor: id,
    isFocusVisible: isFocusVisible
  }, label, /*#__PURE__*/_react["default"].createElement(_VisuallyHidden["default"], null, /*#__PURE__*/_react["default"].createElement("input", _extends({
    checked: checked,
    name: name,
    id: id,
    onChange: onChange,
    type: "radio",
    value: value,
    disabled: isDisabled,
    required: required
  }, focusProps))));
}
Radio.propTypes = {
  checked: _propTypes["default"].bool.isRequired,
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  index: _propTypes["default"].number.isRequired,
  checkedIndex: _propTypes["default"].number.isRequired,
  optionCount: _propTypes["default"].number.isRequired,
  label: _propTypes["default"].string,
  value: _propTypes["default"].any,
  variant: _propTypes["default"].oneOf(['pill', 'grid']).isRequired,
  error: _propTypes["default"].bool,
  warning: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool
};
function RadioGroup(_ref2) {
  var helperText = _ref2.helperText,
    legend = _ref2.legend,
    name = _ref2.name,
    onChange = _ref2.onChange,
    options = _ref2.options,
    value = _ref2.value,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'pill' : _ref2$variant,
    validationMessage = _ref2.validationMessage,
    warningMessage = _ref2.warningMessage,
    touched = _ref2.touched,
    _ref2$required = _ref2.required,
    required = _ref2$required === void 0 ? false : _ref2$required,
    fullWidth = _ref2.fullWidth;
  var optionCount = options.length;
  var checkedIndex = options.findIndex(function (option) {
    return option.value === value;
  });
  return /*#__PURE__*/_react["default"].createElement(_FieldSet["default"], {
    legend: legend,
    helperText: helperText,
    validationMessage: validationMessage,
    warningMessage: warningMessage,
    touched: touched
  }, variant === 'list' ? /*#__PURE__*/_react["default"].createElement(_Stack["default"], {
    space: "space10",
    direction: "column"
  }, options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(_Radio["default"], _extends({
      key: option.value,
      isChecked: value === option.value,
      name: name,
      onChange: onChange,
      hasError: !!validationMessage && touched,
      id: "".concat(name, "-").concat(index),
      required: required
    }, option));
  })) : /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    display: "flex",
    flexWrap: "wrap",
    maxWidth: fullWidth ? '100%' : '486px'
  }, options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(Radio, _extends({
      key: option.value,
      checked: value === option.value,
      checkedIndex: checkedIndex,
      name: name,
      index: index,
      onChange: onChange,
      variant: variant,
      optionCount: optionCount,
      error: !!validationMessage && touched,
      warning: !!warningMessage && touched,
      id: "".concat(name, "-").concat(index),
      required: required
    }, option));
  })));
}
RadioGroup.propTypes = {
  helperText: _propTypes["default"].node,
  legend: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].any.isRequired,
    label: _propTypes["default"].string.isRequired,
    isDisabled: _propTypes["default"].bool
  })).isRequired,
  value: _propTypes["default"].any,
  variant: _propTypes["default"].oneOf(['pill', 'list', 'grid']),
  validationMessage: _propTypes["default"].string,
  warningMessage: _propTypes["default"].string,
  touched: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool
};
var _default = exports["default"] = RadioGroup;